const CopyIcon = ({
  size = 36,
  className = '',
  onClick = (event) => {}
}: {
  size?: number;
  className?: string;
  onClick?: (event) => void;
}) => {
  return (
    <span className={className} onClick={onClick}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={size}
        viewBox='0 0 20 21'
        fill='none'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M9.16666 8.83335C8.70642 8.83335 8.33332 9.20645 8.33332 9.66669V17.1667C8.33332 17.6269 8.70642 18 9.16666 18H16.6667C17.1269 18 17.5 17.6269 17.5 17.1667V9.66669C17.5 9.20645 17.1269 8.83335 16.6667 8.83335H9.16666ZM6.66666 9.66669C6.66666 8.28598 7.78594 7.16669 9.16666 7.16669H16.6667C18.0474 7.16669 19.1667 8.28598 19.1667 9.66669V17.1667C19.1667 18.5474 18.0474 19.6667 16.6667 19.6667H9.16666C7.78594 19.6667 6.66666 18.5474 6.66666 17.1667V9.66669Z'
          fill='currentColor'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M3.33334 3.00001C3.11233 3.00001 2.90037 3.08781 2.74409 3.24409C2.58781 3.40037 2.50001 3.61233 2.50001 3.83334V11.3333C2.50001 11.5544 2.58781 11.7663 2.74409 11.9226C2.90037 12.0789 3.11233 12.1667 3.33334 12.1667H4.16668C4.62691 12.1667 5.00001 12.5398 5.00001 13C5.00001 13.4602 4.62691 13.8333 4.16668 13.8333H3.33334C2.6703 13.8333 2.03442 13.57 1.56558 13.1011C1.09674 12.6323 0.833344 11.9964 0.833344 11.3333V3.83334C0.833344 3.1703 1.09674 2.53442 1.56558 2.06558C2.03442 1.59674 2.6703 1.33334 3.33334 1.33334H10.8333C11.4964 1.33334 12.1323 1.59674 12.6011 2.06558C13.07 2.53442 13.3333 3.1703 13.3333 3.83334V4.66668C13.3333 5.12691 12.9602 5.50001 12.5 5.50001C12.0398 5.50001 11.6667 5.12691 11.6667 4.66668V3.83334C11.6667 3.61233 11.5789 3.40037 11.4226 3.24409C11.2663 3.08781 11.0544 3.00001 10.8333 3.00001H3.33334Z'
          fill='currentColor'
        />
      </svg>
    </span>
  );
};

export default CopyIcon;
